export const apiAddress = 'https://portal-dev.ebhr.com/api/';

export enum ApiRoutes {
  surveyList = 'surveys/',
  login = 'token/',
  refreshToken = 'token/refresh/',
  microsoft = 'login/microsoft/',
  logout = 'token/revoke/',
  passwordReset = '/password-reset/',
  passwordResetValidateToken = '/password-reset/validate-token/',
  passwordResetConfirm = '/password-reset/confirm/',
  contents = '/contents/',
  topicbase = '/topicbase/',
  organizations = '/organizations/',
  projects = '/projects/',
  participantsTeams = 'participants-teams/',
  members = 'members/',
  groupOfReports = '/groups-of-reports/',
  reports = '/reports/',
  surveyResults = '/survey-results/',
  effectSurveyResults = '/effect-survey-results/',
  users = '/users',
  preferences = '/preferences',
  userInfo = '/userinfo/',
  teamsResultsComparison = '/survey-results-comparison/teams/',
  recommendations = '/recommendations/',
  participants = 'participants/',
  reportingGroups = 'reporting-groups/',
  potentialMembers = 'potential-members/',
  downloadPresentation = 'download-presentation/',
  supplementaryResources = 'supplementary-resources/',
  individualReports = '/individual-reports/',
  openQuestions = '/open-questions/',
  schedule = 'schedule/',
  switchOrganization = 'switch-organization/',
}

export interface IApiRoutes {
  [ApiRoutes.surveyList]: string;
  [ApiRoutes.login]: string;
}

export const tokenExceptions: ApiRoutes[] | any = [ApiRoutes.login];

export const refreshTokenExceptions: ApiRoutes[] | any = [
  ApiRoutes.login,
  ApiRoutes.refreshToken,
  ApiRoutes.passwordReset,
  ApiRoutes.passwordResetConfirm,
  ApiRoutes.passwordResetValidateToken,
  ApiRoutes.logout,
];
